import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function ShippingForm({ handleName, state }) {
  const [email, setEmail] = useState("");
  const [hide, setHide] = useState("hidden");
  const navigate = useNavigate();
  const handlevalidation = (e) => {
    e.preventDefault();
    const value = e.target.value;
    setEmail(value);
  };
  const initialValues = {
    email: "",
    fullName: "",
    postalCode: "",
    phoneNumber: "",
  };
  const [formValues, setFormValues] = useState({ initialValues });
  const [formErrors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    setErrors(validate(formValues));
    setIsSubmit(true);
  };
  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      navigate("/finalCheckout");
    }
  }, [formErrors]);
  const validate = (values) => {
    const errors = {};
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const regexName = /^[A-Z][-a-zA-Z]+$/i;
    if (!values.fullName) {
      errors.fullName = "Please your first name";
    } else if (!regexName.test(values.fullName)) {
      errors.fullName = "Enter a valid name";
    }
    if (!values.email) {
      errors.email = "Please enter your Email";
    } else if (!regexEmail.test(values.email)) {
      errors.email = "Enter a valid email";
    }
    if (!values.postalCode) {
      errors.postalCode = "Required**";
    } else if (values.postalCode.length < 5) {
      errors.postalCode = "Must be 5 digits";
    }
    if (!values.phoneNumber) {
      errors.phoneNumber = "Please enter your phone Number";
    } else if (values.phoneNumber.length < 11) {
      errors.phoneNumber = "Must be 11 digits";
    }
    return errors;
  };
  const handleRender = () => {
    return isSubmit;
  };
  return (
    <div className="px-5 mb-24  max-w-[590px] mx-auto">
      <div className="my-10 large:hidden">
        <p className="mb-8 font-satoshi font-medium ">
          <span className="text-[#BCB7B7]">Home/</span>
          <span className="text-[#BCB7B7]">Marketplace/</span>
          <span className="text-black">Shipping</span>
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email" className="text-[#888888] font-satoshi">
            Your Email
          </label>
          <br></br>
          <br></br>
          <input
            type="email"
            name="email"
            value={formValues.email}
            // required
            className="w-full bg-[#F2F2F2] h-[50px] rounded font-satoshi  border border-[#747474] pl-4 :required:border-red-400"
            onChange={handleChange}
          />
        </div>
        <p className="text-red-500 mt-2">{formErrors.email}</p>
        <br></br>
        <div>
          <input
            type="checkbox"
            id="checkbox"
            defaultValue="HTML"
            className="input mr-2"
          />
          <label htmlFor="checkbox" className="text-[#888888] font-satoshi">
            Get updates about new drops & exclusive offers
          </label>
          <br></br>
          <br></br>
        </div>

        <div>
          <label htmlFor="name" className="text-[#888888] font-satoshi">
            Your First name
          </label>
          <br></br>
          <br></br>
          <input
            name="fullName"
            type="text"
            value={formValues.fullName}
            className="w-full bg-[#F2F2F2] h-[50px] font-satoshi rounded  border border-[#747474] pl-4 required"
            onChange={handleChange}
            onClick={(e) => handleName(e)}
          />
        </div>
        <p className="text-red-500 mt-2">{formErrors.fullName}</p>
        <br></br>
        <br></br>
        <div className="flex flex-col md:flex-row md:gap-5">
          <div>
            <label htmlFor="" className="text-[#888888] font-satoshi">
              Country
            </label>
            <br></br>
            <br></br>
            <select
              className=" w-full bg-[#F2F2F2] h-[50px] rounded border border-[#747474] font-satoshi pl-4"
              required
            >
              <option></option>
              <option value="Afghanistan">Afghanistan</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="American Samoa">American Samoa</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Anguilla">Anguilla</option>
              <option value="Antartica">Antarctica</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Aruba">Aruba</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bermuda">Bermuda</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegowina">
                Bosnia and Herzegowina
              </option>
              <option value="Botswana">Botswana</option>
              <option value="Bouvet Island">Bouvet Island</option>
              <option value="Brazil">Brazil</option>
              <option value="British Indian Ocean Territory">
                British Indian Ocean Territory
              </option>
              <option value="Brunei Darussalam">Brunei Darussalam</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Cape Verde">Cape Verde</option>
              <option value="Cayman Islands">Cayman Islands</option>
              <option value="Central African Republic">
                Central African Republic
              </option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Christmas Island">Christmas Island</option>
              <option value="Cocos Islands">Cocos (Keeling) Islands</option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo">Congo</option>
              <option value="Congo">
                Congo, the Democratic Republic of the
              </option>
              <option value="Cook Islands">Cook Islands</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Cota D'Ivoire">Cote d'Ivoire</option>
              <option value="Croatia">Croatia (Hrvatska)</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="East Timor">East Timor</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Falkland Islands">
                Falkland Islands (Malvinas)
              </option>
              <option value="Faroe Islands">Faroe Islands</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="France Metropolitan">France, Metropolitan</option>
              <option value="French Guiana">French Guiana</option>
              <option value="French Polynesia">French Polynesia</option>
              <option value="French Southern Territories">
                French Southern Territories
              </option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Gibraltar">Gibraltar</option>
              <option value="Greece">Greece</option>
              <option value="Greenland">Greenland</option>
              <option value="Grenada">Grenada</option>
              <option value="Guadeloupe">Guadeloupe</option>
              <option value="Guam">Guam</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-Bissau">Guinea-Bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Heard and McDonald Islands">
                Heard and Mc Donald Islands
              </option>
              <option value="Holy See">Holy See (Vatican City State)</option>
              <option value="Honduras">Honduras</option>
              <option value="Hong Kong">Hong Kong</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran">Iran (Islamic Republic of)</option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Democratic People's Republic of Korea">
                Korea, Democratic People's Republic of
              </option>
              <option value="Korea">Korea, Republic of</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Lao">Lao People's Democratic Republic</option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon" selected>
                Lebanon
              </option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libyan Arab Jamahiriya">
                Libyan Arab Jamahiriya
              </option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Macau">Macau</option>
              <option value="Macedonia">
                Macedonia, The Former Yugoslav Republic of
              </option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Martinique">Martinique</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mayotte">Mayotte</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia">
                Micronesia, Federated States of
              </option>
              <option value="Moldova">Moldova, Republic of</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montserrat">Montserrat</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar">Myanmar</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="Netherlands Antilles">Netherlands Antilles</option>
              <option value="New Caledonia">New Caledonia</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="Niue">Niue</option>
              <option value="Norfolk Island">Norfolk Island</option>
              <option value="Northern Mariana Islands">
                Northern Mariana Islands
              </option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Pitcairn">Pitcairn</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Puerto Rico">Puerto Rico</option>
              <option value="Qatar">Qatar</option>
              <option value="Reunion">Reunion</option>
              <option value="Romania">Romania</option>
              <option value="Russia">Russian Federation</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Kitts and Nevis">
                Saint Kitts and Nevis
              </option>
              <option value="Saint LUCIA">Saint LUCIA</option>
              <option value="Saint Vincent">
                Saint Vincent and the Grenadines
              </option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">
                Sao Tome and Principe
              </option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia (Slovak Republic)</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Georgia">
                South Georgia and the South Sandwich Islands
              </option>
              <option value="Span">Spain</option>
              <option value="SriLanka">Sri Lanka</option>
              <option value="St. Helena">St. Helena</option>
              <option value="St. Pierre and Miguelon">
                St. Pierre and Miquelon
              </option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Svalbard">Svalbard and Jan Mayen Islands</option>
              <option value="Swaziland">Swaziland</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syria">Syrian Arab Republic</option>
              <option value="Taiwan">Taiwan, Province of China</option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania">Tanzania, United Republic of</option>
              <option value="Thailand">Thailand</option>
              <option value="Togo">Togo</option>
              <option value="Tokelau">Tokelau</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Turks and Caicos">Turks and Caicos Islands</option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="United States Minor Outlying Islands">
                United States Minor Outlying Islands
              </option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Vietnam">Viet Nam</option>
              <option value="Virgin Islands (British)">
                Virgin Islands (British)
              </option>
              <option value="Virgin Islands (U.S)">
                Virgin Islands (U.S.)
              </option>
              <option value="Wallis and Futana Islands">
                Wallis and Futuna Islands
              </option>
              <option value="Western Sahara">Western Sahara</option>
              <option value="Yemen">Yemen</option>
              <option value="Serbia">Serbia</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </select>
          </div>
          <br></br>
          <div>
            <label htmlFor="" className="text-[#888888] font-satoshi">
              Postal Code
            </label>
            <br></br>
            <br></br>
            <input
              type="number"
              name="postalCode"
              value={formValues.postalCode}
              className=" w-full bg-[#F2F2F2] h-[50px] rounded  border border-gray-500  font-satoshi pl-4"
              placeholder="0010001"
              onChange={handleChange}
            />
            <p className="text-red-500 mt-2">{formErrors.postalCode}</p>
          </div>
        </div>
        <br></br>
        <div>
          <label htmlFor="" className="text-[#888888] font-satoshi">
            Phone Number
          </label>
          <br></br>
          <br></br>
          <input
            type="number"
            value={formValues.phoneNumber}
            name="phoneNumber"
            onChange={handleChange}
            className="w-full bg-[#F2F2F2 ] font-satoshi h-[50px] rounded  border border-gray-500 pl-4"
          />
          <p className="text-red-500 mt-2">{formErrors.phoneNumber}</p>
        </div>

        <br></br>
        <br></br>
        <p className={`font-satoshi text-xl text-red-500 ${hide}`}>
          Please fill all input field**
        </p>
        <br></br>
        {/* <Link */}
        {/* to="/finalCheckout"
          className=" w-full bg-[#3341C1] h-[57px] rounded-sm text-white font-satoshi flex items-center justify-center  text-lg md:text-xl" */}
        {/* > */}
        <button
          type="submit"
          onClick={handleRender}
          className="w-full bg-[#3341C1] h-[57px] rounded-sm text-white font-satoshi flex items-center justify-center  text-lg md:text-xl"
        >
          Proceed to Payment
        </button>
        {/* </Link> */}
      </form>
    </div>
  );
}

export default ShippingForm;
